import { render, staticRenderFns } from "./DashboardUpdatesCard.vue?vue&type=template&id=2fc32aa5&scoped=true&"
import script from "./DashboardUpdatesCard.vue?vue&type=script&lang=js&"
export * from "./DashboardUpdatesCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUpdatesCard.vue?vue&type=style&index=0&id=2fc32aa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc32aa5",
  null
  
)

export default component.exports